import request from './request'

export const fetchCountries = () => {
    return new Promise((resolve, reject) => {
        request.get(`countries`)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}